import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { getImmutableCompatible } from 'src/utils/immutableUtils';

import { name } from './slice';
import type { HotelsState } from './types';

const hotelsSelector = (state): HotelsState =>
  getImmutableCompatible(state, name);

export const hotelsListSelector = createSelector(
  hotelsSelector,
  (state) => state.list,
);

export const hotelsVisibilitySelector = createSelector(
  hotelsSelector,
  (state) => state.areHotelsVisible,
);

export const penalizedHotelsVisibilitySelector = createSelector(
  hotelsSelector,
  (state) => state.arePenalizedHotelsVisible,
);

export const isEmptyHotelsListSelector = createSelector(
  hotelsSelector,
  (state) => state.list && isEmpty(state.list),
);

/**
 * Если массив индексов видимых отелей не пуст,
 * то берем максимальный индекс (индекс самого нижнего отеля во viewport)
 */
export const latestVisibleHotelSelector = createSelector(
  hotelsSelector,
  (state) =>
    state.currentVisibleHotels.length
      ? Math.max(...state.currentVisibleHotels)
      : null,
);

export const latestVisiblePenalizedHotelSelector = createSelector(
  hotelsSelector,
  (state) =>
    state.currentVisiblePenalizedHotels.length
      ? Math.max(...state.currentVisiblePenalizedHotels)
      : null,
);

export const getHotelsLengthSelector = createSelector(
  hotelsListSelector,
  (hotels) => hotels.length || 0,
);

export const hotelsCountSelector = createSelector(
  hotelsSelector,
  (state) => state.hotelsCount,
);

export const prevHotelsCountSelector = createSelector(
  hotelsSelector,
  (state) => state.prevHotelsCount,
);

export const isEmptyHotelsCountSelector = createSelector(
  hotelsSelector,
  (state) => state.hotelsCount === 0,
);

export const hotelsVisibleLimitSelector = createSelector(
  hotelsSelector,
  (state) => state.visibleLimit,
);

export const hotelsPageNumberSelector = createSelector(
  hotelsSelector,
  (state) => state.pageNumber,
);

export const hotelsHasPaginationSelector = createSelector(
  hotelsSelector,
  (state) => state.hasPagination,
);

export const isVisibleShowMoreHotelsSelector = createSelector(
  [getHotelsLengthSelector, hotelsVisibleLimitSelector],
  (hotelsLength, visibleLimit) => hotelsLength > visibleLimit,
);

export const topHotelNameSelector = createSelector(
  hotelsSelector,
  (state) => state.topHotelName,
);

export const isTopHotelNotFoundSelector = createSelector(
  hotelsSelector,
  (state) => state.isTopHotelNotFound,
);
